/** Store in-memory cu note IDs care au draft local. Re-populat la mount
 *  NotesList din localStorage și sincronizat la writeDraft/clearDraft. */
import { create } from 'zustand';

interface DraftsState {
  withDraft: Set<string>;
  hasDraft: (noteId: string) => boolean;
  markDraft: (noteId: string) => void;
  clearDraft: (noteId: string) => void;
  setAll: (ids: string[]) => void;
  resetAll: () => void;
}

export const useDraftsStore = create<DraftsState>((set, get) => ({
  withDraft: new Set(),
  hasDraft: (noteId) => get().withDraft.has(noteId),
  markDraft: (noteId) =>
    set((s) => {
      if (s.withDraft.has(noteId)) return s;
      const next = new Set(s.withDraft);
      next.add(noteId);
      return { withDraft: next };
    }),
  clearDraft: (noteId) =>
    set((s) => {
      if (!s.withDraft.has(noteId)) return s;
      const next = new Set(s.withDraft);
      next.delete(noteId);
      return { withDraft: next };
    }),
  setAll: (ids) => set({ withDraft: new Set(ids) }),
  resetAll: () => set({ withDraft: new Set() }),
}));
